module.exports = __webpack_public_path__ + "static/img/prize2.49187e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/page_activitycenter/prize2.png
// module id = RVCx
// module chunks = 1